<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_AREA' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_AREA' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- code -->
    <div fxLayout>
      <mat-form-field>
        <input
          #code
          matInput
          required
          autocomplete="off" 
          formControlName="code" 
          [placeholder]="'LABEL_CODE' | translate"
          >

        <mat-error *ngIf="formGroup.get('code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('code').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '20'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- description -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #description 
          autocomplete="off" 
          formControlName="description" 
          [placeholder]="'LABEL_DESCRIPTION' | translate"
          >

        <mat-error *ngIf="formGroup.controls['description'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.controls['description'].hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '50'} }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>

  </div>
</form>